import React from 'react';
import MilestoneList from '../../components/Milestones/MilestoneList';

const MilestoneListPage = () => {
  return <MilestoneList />;
};

export default MilestoneListPage;


